import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
// import Media from 'reactstrap/lib/Media';
import Pagination from 'reactstrap/lib/Pagination';
import PaginationItem from 'reactstrap/lib/PaginationItem';
import PaginationLink from 'reactstrap/lib/PaginationLink';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import Label from 'reactstrap/lib/Label';
import Input from 'reactstrap/lib/Input';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';

import Moment from 'react-moment';
import Spinner from 'reactstrap/lib/Spinner';

import RoomLogs from './RoomLogs';
import * as constants from '../../../constants/constants';
import DateFormat from '../UI/DateFormat';
import CountDownDate from '../UI/CountDownDate';
import Select from 'react-select';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import PaginationOld from '../Menu/PaginationOld';

class AdminLogsRooms extends React.Component {
  static propTypes = {
    member: PropTypes.shape({
      email: PropTypes.string,
    }),
    //  allRooms: PropTypes.shape({}),
    allRooms: PropTypes.arrayOf(PropTypes.shape({})),
    allRoomsLoading: PropTypes.bool,
    roomData: PropTypes.shape({}),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    fetchBots: PropTypes.func.isRequired,
    fetchRoomLog: PropTypes.func.isRequired,
    fetchRoomLogsRange: PropTypes.func.isRequired,
    filteredRoomsLogs: PropTypes.shape({}),
    filteredRoomsLogsLoading: PropTypes.bool,
    fetchFilteredRoomLogs: PropTypes.func.isRequired,
    roomsPlayedCount: PropTypes.number,
    totalRoomCount: PropTypes.number,
    bots: PropTypes.shape({}),
    searchUid: PropTypes.string,
  }

  static defaultProps = {
    member: {},
    allRooms: [],
    roomData: {},
    filteredRoomsLogs: null,
    roomsPlayedCount: 0,
    bots: {},
    searchUid: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      pageSize: 50,
      //  roomFilter: '',
      //  tournamentFilter: '',
      filteredRoomsLogs: null,
      filter: props.searchUid || '',
      filterType: props.searchUid ? 'userId' : 'roomId',
      filterMinValue: [],
      filterSpeed: '',
      filterGames: '',
      filterBet: [],
      filterGameType: [],
      filterPlatform: [],
      filterAmountOfPlayer: '',
      filterByTimeBetween: '',
      filterByTimeBetweenTime: '',
      filterCloseReason: '',
      showBotRoom: false,
      filterBots: '',
      filterTournament: '',
      showActiveRooms: false,
      showMergedRooms: false,
      showAutoPlayRooms: false,
      excludeLeftBeforeStartRooms: false,
      onlyPenaltyRooms: false,
      startDate: new Date(Date.now() - 24 * 60 * 60 * 1000),
      endDate: new Date(),
      startCalendarDate: new Date(Date.now() - 24 * 60 * 60 * 1000),
      endCalendarDate: new Date(),
      winPointsFrom: '',
      winPointsTo: '',
      winCoinsFrom: '',
      winCoinsTo: '',
      lossPointsFrom: '',
      lossPointsTo: '',
      lossCoinsFrom: '',
      lossCoinsTo: '',
    };

    this.toggle = this.toggle.bind(this);
    this.openModal = this.openModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillUnmount = () => {
    const { fetchFilteredRoomLogs } = this.props;

    fetchFilteredRoomLogs('');
  }


  filter = () => {
    const { fetchFilteredRoomLogs } = this.props;
    const {
      filter,
      filterType,
      filterMinValue,
      filterSpeed,
      filterGames,
      filterBet,
      filterGameType,
      filterPlatform,
      filterAmountOfPlayer,
      filterCloseReason,
      filterBots,
      showActiveRooms,
      showMergedRooms,
      showAutoPlayRooms,
      excludeLeftBeforeStartRooms,
      onlyPenaltyRooms,
      filterTournament,
      startDate,
      endDate,
      filterByTimeBetween,
      filterByTimeBetweenTime,
      winPointsFrom,
      winPointsTo,
      winCoinsFrom,
      winCoinsTo,
      lossPointsFrom,
      lossPointsTo,
      lossCoinsFrom,
      lossCoinsTo,
    } = this.state;
    
    console.log(filter, filterType, filterMinValue, filterSpeed, filterGames, filterBet, filterGameType, filterPlatform, filterAmountOfPlayer, filterCloseReason, filterBots, "filterCheckRooms");

    console.log('filterAmountOfPlayer', filterAmountOfPlayer);

    if (Date.parse(startDate) > Date.parse(endDate)) return ;

    this.setState({
      currentPage: 0,
    });

    fetchFilteredRoomLogs(
      filter,
      filterType,
      this.getValuesArray(filterMinValue),
      this.getValuesArray(filterPlatform),
      filterSpeed,
      filterGames,
      this.getValuesArray(filterBet),
      this.getValuesArray(filterGameType),
      filterAmountOfPlayer,
      filterCloseReason,
      filterByTimeBetween,
      filterByTimeBetweenTime,
      filterBots,
      filterTournament,
      showActiveRooms,
      showMergedRooms,
      showAutoPlayRooms,
      excludeLeftBeforeStartRooms,
      onlyPenaltyRooms,
      Date.parse(startDate),
      Date.parse(endDate),
      winPointsFrom,
      winPointsTo,
      winCoinsFrom,
      winCoinsTo,
      lossPointsFrom,
      lossPointsTo,
      lossCoinsFrom,
      lossCoinsTo,
    );
  }

  resetFilters = () => {
    this.setState({
      filtersOpen: false,
      filter: '',
      filterType: 'roomId',
      filterMinValue: [],
      filterSpeed: '',
      filterGames: '',
      filterBet: [],
      filterGameType: [],
      filterPlatform: [],
      filterAmountOfPlayer: '',
      filterByTimeBetween: '',
      filterByTimeBetweenTime: '',
      filterCloseReason: '',
      showBotRoom: false,
      filterBots: '',
      filterTournament: '',
      showActiveRooms: false,
      showMergedRooms: false,
      showAutoPlayRooms: false,
      excludeLeftBeforeStartRooms: false,
      onlyPenaltyRooms: false,
      startDate: new Date(Date.now() - 24 * 60 * 60 * 1000),
      endDate: new Date(),
      startCalendarDate: new Date(Date.now() - 24 * 60 * 60 * 1000),
      endCalendarDate: new Date(),
      winPointsFrom: '',
      winPointsTo: '',
      winCoinsFrom: '',
      winCoinsTo: '',
      lossPointsFrom: '',
      lossPointsTo: '',
      lossCoinsFrom: '',
      lossCoinsTo: '',
    });
  }

  selectType = (e) => {
    this.setState({ filterType: e.target.value });
  }

  selectSpeed = (e) => {
    this.setState({ filterSpeed: e.target.value });
  }

  selectBet = (filterBet) => {
    this.setState({ filterBet });
  }

  selectGameType = (filterGameType) => {
    this.setState({ filterGameType });
  }

  selectPlatform = (filterPlatform) => {
    this.setState({ filterPlatform });
  }

  selectBots = (e) => {
    this.setState({ filterBots: e.target.value });
  }

  selectTournament = (e) => {
    this.setState({ filterTournament: e.target.value });
  }

  selectFilterMinValue = (filterMinValue) => {
    this.setState({ filterMinValue });
  }

  selectAmountOfPlayer = (e) => {
    this.setState({ filterAmountOfPlayer: e.target.value });
  }

  selectCloseReason = (filterCloseReason) => {
    this.setState({ filterCloseReason });
  }

  selectFilterByTimeBetween = (e) => {
    this.setState({ filterByTimeBetween: e.target.value });
  }

  handleKeyPress = (target) => {
    if (target.charCode === constants.ENTERKEY) {
      this.filter();
    }
  }

  handleChange(event) {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    this.setState({
      [event.target.name]: value,
    });
  }

  toggle() {
    this.setState(prevState => ({
      openModal: !prevState.openModal,
    }));
  }

  toggleBotRoom(showBotRoom) {
    this.setState({
      showBotRoom,
    });

    if (showBotRoom) {
      this.setState({
        filterType: 'hasBots',
      });
    } else {
      this.setState({
        filterType: '',
      });
    }
  }

  openModal(room) {
    const { fetchRoomLog, bots, fetchBots } = this.props;

    if (!bots || !Object.keys(bots).length) {
      fetchBots();
    }

    console.log('openModal', room);

    fetchRoomLog(room.roomId);
    this.setState({
      roomId: room.roomId,
      room,
      openModal: true,
    });
  }

  handleClick(e, index) {
    e.preventDefault();

    const { fetchRoomLogsRange, roomsPlayedCount, filteredRoomsLogs } = this.props;
    if (filteredRoomsLogs && filteredRoomsLogs.length > 0) {
      console.log('has filtered');
    } else {
      const end = roomsPlayedCount - (50 * index);
      const start = roomsPlayedCount - ((50 * index) + 50);

      fetchRoomLogsRange(start, end);
    }
    this.setState({
      currentPage: index,
    });
  }

  changeStartDate = (date) => {
    this.setState({ startDate: date });
  }

  changeEndDate = (date) => {
    this.setState({ endDate: date });
  }

  changeStartCalendarDate = (date) => {
    this.setState({ startCalendarDate: date });
  }

  changeEndCalendarDate = (date) => {
    this.setState({ endCalendarDate: date});
  }

  getValuesArray = (options) => {
    let values = [];
    for (const option of options) {
      values.push(option.value);
    }
    return values;
  }

  numbersOnly = (e) => {
    if (!((e.key >= '0' && e.key <= '9') || e.key === 'Backspace' || e.key === 'Delete')) { e.preventDefault(); }
  }

  table() {
    const {
      allRooms,
      allRoomsLoading,
      roomsPlayedCount,
      filteredRoomsLogs,
      filteredRoomsLogsLoading,
      t,
      offset,
    } = this.props;
    const {
      currentPage,
      pageSize,
      filterCloseReason,
    } = this.state;

  //  console.log('filteredRoomsLogs', filterCloseReason, filteredRoomsLogs, this.props.filteredRoomsLogs);

    let rooms = allRooms;
    let pagesCount = Math.ceil(roomsPlayedCount / pageSize);

    if (filteredRoomsLogs && (filteredRoomsLogs.length || filteredRoomsLogs.length === 0)) {
      rooms = filteredRoomsLogs.slice(
        currentPage * pageSize,
        (currentPage + 1) * pageSize,
      );
      pagesCount = Math.ceil(filteredRoomsLogs.length / pageSize);
    }

  //  console.log('rooms', rooms);

    if (filteredRoomsLogsLoading || allRoomsLoading) {
      return (
        <Spinner type="grow" color="warning" style={{ width: '2rem', height: '2rem' }} />
      );
    }
  //  console.log(rooms, "checkGameErrorRooms")

    if (!rooms.length) {
      return null;
    }

    return (
      <Fragment>
        {rooms
          .map((room, index) => (
            <Fragment key={room.roomId}>
              <tr key={room.roomId} className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}>
                <td className="allUsers-table-col">
                  {room.date && (
                    <DateFormat formatType={constants.FORMAT_DATE_TYPE.fullDateSecond} date={room.date + offset} />
                  )}
                </td>
                <td className="allUsers-table-col">
                  {room.roomId}
                </td>
                <td className="allUsers-table-col">
                  {room.tournamentId}
                </td>
                <td style={{ color: (room.closeReason && room.closeReason === constants.FILTER_CLOSE_REASON.missedTurn) ? "red" : "#FFF" }} className="allUsers-table-col">
                  {room.closeReason === 'missedTurn' ? (
                    <Fragment>
                      {`${room.closeReason} (${room.isOnline ? 'online' : 'offline'}, ${room.triedToMove ? 'tried to move' : "didn't try to move"})`}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {room.closeReason || ''}

                      {(room?.leaveReason || room?.leaveReason4thPlayer) && (
                        <>
                            <Button color="primary" id={`room-leave-reason-${room.roomId}`}>
                                ?
                            </Button>
                            <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target={`room-leave-reason-${room.roomId}`}>
                                <PopoverBody className="popover-body">
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                      {room?.leaveReason}
                                      {room?.leaveReason4thPlayer}
                                    </div>
                                </PopoverBody>
                            </UncontrolledPopover>
                        </>
                      )}
                    </Fragment>
                  )}

                </td>
                <td className="allUsers-table-col">
                  {room?.secondUserJoined ? (
                    <CountDownDate showOption="admin_report" date={room?.secondUserJoined} newDate={room.date} showWithoutText={true} />
                  ) : ('-')}
                </td>
                <td className="allUsers-table-col">
                  {room?.firstRoundStart ? (
                    <CountDownDate showOption="admin_report" date={room?.firstRoundStart} newDate={room.date} showWithoutText={true} />
                  ) : ('-')}
                </td>
                <td className="allUsers-table-col">
                  {room?.closeTime ? (
                    <CountDownDate showOption="admin_report" date={room.closeTime} newDate={room.date} showWithoutText={true} />
                  ) : ('-')}
                </td>
                <td className="allUsers-table-col">
                  {room.closeTime && (
                    <DateFormat formatType={constants.FORMAT_DATE_TYPE.fullDateSecond} date={room.closeTime + offset} />
                  )}
                </td>
                <td className="allUsers-table-col">
                  {
                    filterCloseReason === constants.GAMEERROR ? (
                      room?.partyCount || 0
                    ) : (
                      room?.party || 0
                    )
                  }
                </td>
                <td className="allUsers-table-col">
                  <Button color="primary" onClick={() => this.openModal(room)}>
                    View
                  </Button>
                </td>
              </tr>
            </Fragment>
          ))}

          <div className="d-flex justify-content-center align-items-center">
            <PaginationOld
                show={true}
                currentPage={currentPage}
                pagesCount={pagesCount}
                handlePagination={this.handleClick}
            />
          </div>
          

      </Fragment>
    );
  }

  render() {
    const { roomData, t, bots, totalRoomCount, filteredRoomsLogs, filteredRoomsLogsLoading, allRoomsLoading, offset } = this.props;

    const {
      filtersOpen,
      openModal,
      roomId,
      room,
      filterType,
      filter,
      filterMinValue,
      showBotRoom,
      filterBots,
      filterTournament,
      filterSpeed,
      filterGames,
      filterBet,
      filterGameType,
      filterPlatform,
      filterAmountOfPlayer,
      filterCloseReason,
      startDate,
      endDate,
      filterByTimeBetween,
      filterByTimeBetweenTime,
      showActiveRooms,
      showMergedRooms,
      showAutoPlayRooms,
      excludeLeftBeforeStartRooms,
      onlyPenaltyRooms,
      // filteredRoomsLogs,
      winPointsFrom,
      winPointsTo,
      winCoinsFrom,
      winCoinsTo,
      lossPointsFrom,
      lossPointsTo,
      lossCoinsFrom,
      lossCoinsTo,
      startCalendarDate,
      endCalendarDate,
    } = this.state;

    const multiSelectStyle = {
      menu: (provided) => ({
        ...provided,
        backgroundColor: 'white',
      }),
      option: (provided, state) => ({
        ...provided,
        color: state.isFocused ? 'white' : '#495057',
        padding: '5px 10px',
        height: 'auto',

      }),
    };

    const multiSelectTheme = (theme) => ({
      ...theme,
      borderRadius: 0,
      colors: {
        ...theme.colors,
        primary25: 'rgb(25, 103, 210)',
      },
    })
    

    return (
      <Fragment>
        <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-admin-logs-rooms">
          <PopoverBody className="popover-body">
            A list of all finished and ongoing rooms with an option to view details of each of them. Note: Room details are only available for the last 14 days.
          </PopoverBody>
        </UncontrolledPopover>
        <div className="admin-page-content">
          <h2>
            Rooms
            <Button className="admin-help-button mr-4" id="admin-help-button-admin-logs-rooms">
              ?
            </Button>
          </h2>

          <Row>
            <Col sm="2">
              Search Rooms
            </Col>
            <Col sm="10">
              <Row>
                <Col sm="2">
                  <Label for="filterType">
                    Search by
                  </Label>
                  <Input type="select" className="game-bet-select" value={filterType} onChange={this.selectType}>
                    <option value="roomId">Room Id</option>
                    <option value="tournamentId">Tournament Id</option>
                    <option value="userId">Player Id</option>
                    <option value="lastIp">Last Ip</option>

                  </Input>
                </Col>

                <Col sm="2">
                  <Label for="filter">
                    Value
                  </Label>
                  <Input
                    type="text"
                    name="filter"
                    id="filter"
                    value={filter}
                    onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                  />
                </Col>
                <Col sm="2" style={showActiveRooms ? {opacity: 0.5, pointerEvents: 'none'} : {}}>
                  <Label for="startDate">
                    From
                  </Label>
                  <Row>
                    <Col md="12">
                      <DateTimePicker
                        format="DD.MM.YYYY HH:mm"
                        culture="en"
                        onChange={(date) => this.changeStartDate(date)}
                        value={startDate}
                        defaultCurrentDate={startCalendarDate}
                        currentDate={startCalendarDate}
                        onCurrentDateChange={(date) => this.changeStartCalendarDate(date)}
                        defaultValue={new Date(Date.now() - 24 * 60 * 60 * 1000)}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col sm="2" style={showActiveRooms ? {opacity: 0.5, pointerEvents: 'none'} : {}}>
                  <Label for="endDate">
                    To
                  </Label>
                  <Row>
                    <Col md="12">
                      <DateTimePicker
                        format="DD.MM.YYYY HH:mm"
                        culture="en"
                        onChange={this.changeEndDate}
                        value={endDate}
                        defaultCurrentDate={endCalendarDate}
                        currentDate={endCalendarDate}
                        onCurrentDateChange={(date) => this.changeEndCalendarDate(date)}
                        defaultValue={new Date()}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col sm="2" className="d-flex flex-column" style={{alignItems: 'start'}}>
                  <Label for="filterBotRoomCheck" check style={{marginLeft: 19}}>
                    <Input id="filterBotRoomCheck" type="checkbox" onClick={() => this.setState({showActiveRooms: !showActiveRooms})} checked={showActiveRooms} readOnly />
                    <span className="checkmark" />
                    Show only active rooms
                  </Label>
                  <Label for="filterMergedRoomCheck" check style={{marginLeft: 19}}>
                    <Input id="filterMergedRoomCheck" type="checkbox" onClick={() => this.setState({showMergedRooms: !showMergedRooms})} checked={showMergedRooms} readOnly />
                    <span className="checkmark" />
                    Show only merged rooms
                  </Label>
                  <Label for="filterAutoPlayRoomCheck" check style={{marginLeft: 19}}>
                    <Input id="filterAutoPlayRoomCheck" type="checkbox" onClick={() => this.setState({showAutoPlayRooms: !showAutoPlayRooms})} checked={showAutoPlayRooms} readOnly />
                    <span className="checkmark" />
                    Show only rooms with auto-play
                  </Label>
                </Col>
                <Col sm="2" className="d-flex flex-column" style={{alignItems: 'start'}}>
                  <Label for="filterLeftBeforeStartRoomCheck" check style={{marginLeft: 19}}>
                    <Input id="filterLeftBeforeStartRoomCheck" type="checkbox" onClick={() => this.setState({excludeLeftBeforeStartRooms: !excludeLeftBeforeStartRooms})} checked={excludeLeftBeforeStartRooms} readOnly />
                    <span className="checkmark" />
                    Exclude "Left Before Start" rooms
                  </Label>
                  <Label for="filterOnlyPenaltyRooms" check style={{marginLeft: 19}}>
                    <Input id="filterOnlyPenaltyRooms" type="checkbox" onClick={() => this.setState({onlyPenaltyRooms: !onlyPenaltyRooms})} checked={onlyPenaltyRooms} readOnly />
                    <span className="checkmark" />
                    Show only rooms with penalties
                  </Label>
                </Col>



              </Row>
            </Col>
          </Row>

          <Row>
            <Col sm="2">
              Filter Rooms

              <div className="admin-arrow-wrapper ml-2" onClick={() => this.setState({filtersOpen: !filtersOpen})}>
                <div className={filtersOpen ? 'admin-arrow-down' : 'admin-arrow-up'} />
              </div>
            </Col>
            <Col sm="10" style={filtersOpen ? {} : {display: 'none'}}>
              <Row>
                <Col sm="2">
                  <Label for="filterSpeed">
                    Speed
                  </Label>
                  <Input type="select" className="game-bet-select" value={filterSpeed} onChange={this.selectSpeed}>
                    <option value=""></option>
                    <option value="lightning">Lightning</option>
                    <option value="veryFast">Very Fast</option>
                    <option value="atra">Fast</option>
                    <option value="parasta">Slow</option>
                    <option value="unlimited">Unlimited</option>

                  </Input>
                </Col>
                <Col sm="2">
                  <Label for="filterBet">
                    Bet
                  </Label>
                  <Select
                    isMulti
                    value={filterBet}
                    onChange={this.selectBet}
                    closeMenuOnSelect={false}
                    theme={multiSelectTheme}
                    styles={multiSelectStyle}
                    options={[
                      { value: '1:10', label: '1:10' },
                      { value: '1:25', label: '1:25' },
                      { value: '1:50', label: '1:50' },
                      { value: '1:100', label: '1:100' },
                      { value: '1:250', label: '1:250' },
                      { value: '1:500', label: '1:500' },
                      { value: '1:1000', label: '1:1000' },
                      { value: '1:5000', label: '1:5000' },
                      { value: '1:10000', label: '1:10000' }
                    ]}
                  />
                </Col>
                <Col sm="2">
                  <Label for="filterBet">
                    Type
                  </Label>
                  <Select
                    isMulti
                    value={filterGameType}
                    onChange={this.selectGameType}
                    closeMenuOnSelect={false}
                    theme={multiSelectTheme}
                    styles={multiSelectStyle}
                    options={[
                      { value: 'P', label: 'P' },
                      { value: 'PM', label: 'PM' },
                      { value: 'G', label: 'G' },
                      { value: 'MG', label: 'MG' },
                      { value: 'Private', label: 'Private' },
                    ]}
                  />
                </Col>
                <Col sm="2">
                  <Label for="filterSpeed">
                    Players
                  </Label>
                  <Input type="select" className="game-bet-select" value={filterAmountOfPlayer} onChange={this.selectAmountOfPlayer}>
                    <option value=""></option>
                    <option value="3players">3 Players</option>
                    <option value="4players">4 Players</option>
                    <option value="2players">2 Players</option>
                  </Input>
                </Col>
                <Col sm="2">
                  <Label for="filter">
                    Min games
                  </Label>
                  <Select
                    isMulti
                    value={filterMinValue}
                    onChange={this.selectFilterMinValue}
                    closeMenuOnSelect={false}
                    theme={multiSelectTheme}
                    styles={multiSelectStyle}
                    options={[
                      { value: '1', label: 1 },
                      { value: '3', label: 3 },
                      { value: '5', label: 5 },
                      { value: '10', label: 10 },
                      { value: '15', label: 15 },
                      { value: '20', label: 20 },
                      { value: '25', label: 25 },
                    ]}
                  />
                </Col>
                <Col sm="2">
                  <Label for="filterSpeed">
                    Closing Reason
                  </Label>
                  {/* <Input type="select" className="game-bet-select" value={filterCloseReason} onChange={this.selectCloseReason}>
                    <option value="" className="background-222" />
                    {
                      constants.closeReason.map((item) => {
                        return (
                          <option className="background-222" value={item.id}>
                            {item.label}
                          </option>
                        );
                      })
                    }
                  </Input> */}
                  <Select
                    isMulti
                    value={filterCloseReason}
                    onChange={this.selectCloseReason}
                    closeMenuOnSelect={false}
                    theme={multiSelectTheme}
                    styles={multiSelectStyle}
                    options={constants.closeReason.map(({ id, label }) => ({
                      value: id,
                      label,
                    }))}
                  />
                </Col>

                <Col sm="2">
                  <Label for="filterBet">
                    Platform
                  </Label>
                  <Select
                    isMulti
                    value={filterPlatform}
                    onChange={this.selectPlatform}
                    closeMenuOnSelect={false}
                    theme={multiSelectTheme}
                    styles={multiSelectStyle}
                    options={[
                      { value: 'web', label: 'Web' },
                      { value: 'ios', label: 'iOS' },
                      { value: 'android', label: 'Android' },
                    ]}
                  />
                </Col>
                <Col sm="2">
                  <Label for="filterSpeed">
                    Tournament
                  </Label>
                  <Input type="select" className="game-bet-select" value={filterTournament} onChange={this.selectTournament}>
                    <option value=""></option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </Input>
                </Col>
                <Col sm="2">
                  <Label for="filterSpeed">
                    Bots
                  </Label>
                  <Input type="select" className="game-bet-select" value={filterBots} onChange={this.selectBots}>
                    <option value=""></option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </Input>
                </Col>
                <Col sm="2">
                  <Label for="filter">
                    Games
                  </Label>
                  <Input
                    type="number"
                    name="filterGames"
                    id="filterGames"
                    value={filterGames}
                    onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                  />
                </Col>

                <Col sm="2">
                  <Label for="filterSpeed">
                    Time between
                  </Label>
                  <Input type="select" className="game-bet-select" value={filterByTimeBetween} onChange={this.selectFilterByTimeBetween}>
                    <option value=""></option>
                    <option value="secondUserJoinedTimeTaken">time between creating a room and joining second player</option>
                    <option value="firstRoundStartTimeTaken">time between creating room and starting to play</option>
                    <option value="closeTimeTimeTaken">time between create and close</option>
                  </Input>
                </Col>

                <Col sm="2">
                  <Label for="filterSpeed">
                    Value (minutes)
                  </Label>
                  <Input
                    type="number"
                    name="filterByTimeBetweenTime"
                    id="filterByTimeBetweenTime"
                    value={filterByTimeBetweenTime}
                    onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  Winnings
                </Col>
                <Col sm="2">
                  <Label for="filterSpeed">Points (From / To)</Label>
                </Col>
                <Col sm="2">
                  <Label for="filterSpeed">Coins (From / To)</Label>
                </Col>
                <Col sm="2">
                  Losses
                </Col>
                <Col sm="2">
                  <Label for="filterSpeed">Points (From / To)</Label>
                </Col>
                <Col sm="2">
                  <Label for="filterSpeed">Coins (From / To)</Label>
                </Col>
              </Row>
              <Row>
                <Col sm="2"/>
                <Col sm="1">
                  <Input
                    type="number"
                    name="winPointsFrom"
                    id="winPointsFrom"
                    value={winPointsFrom}
                    // onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}


                    onChange={(e) => {
                      let raw = e.target.value;

                      if (raw.length > 9) {
                        raw = raw.slice(0, 9);
                      }

                      if (raw === '') {
                        this.setState({ winPointsFrom: '' });
                        return;
                      }

                      const num = Number(raw);
                      const value = Math.max(0, num);
                      this.setState({ winPointsFrom: value });
                    }}
                    onBlur={() => {
                      if (winPointsFrom === '') {
                        this.setState({ winPointsFrom: 0 });
                      }
                    }}
                    onKeyDown={this.numbersOnly}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
                <Col sm="1">
                  <Input
                    type="number"
                    name="winPointsTo"
                    id="winPointsTo"
                    value={winPointsTo}
                    // onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) => {
                      let raw = e.target.value;

                      if (raw.length > 9) {
                        raw = raw.slice(0, 9);
                      }

                      if (raw === '') {
                        this.setState({ winPointsTo: '' });
                        return;
                      }

                      const num = Number(raw);
                      const value = Math.max(0, num);
                      this.setState({ winPointsTo: value });
                    }}
                    onBlur={() => {
                      if (winPointsTo === '') {
                        this.setState({ winPointsTo: 0 });
                      }
                    }}
                    onKeyDown={this.numbersOnly}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
                <Col sm="1">
                  <Input
                    type="text"
                    name="winCoinsFrom"
                    id="winCoinsFrom"
                    value={winCoinsFrom}
                    // onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}


                    onChange={(e) => {
                      let raw = e.target.value;

                      if (raw.length > 9) {
                        raw = raw.slice(0, 9);
                      }

                      if (raw === '') {
                        this.setState({ winCoinsFrom: '' });
                        return;
                      }

                      const num = Number(raw);
                      const value = Math.max(0, num);
                      this.setState({ winCoinsFrom: value });
                    }}
                    onBlur={() => {
                      if (winCoinsFrom === '') {
                        this.setState({ winCoinsFrom: 0 });
                      }
                    }}
                    onKeyDown={this.numbersOnly}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
                <Col sm="1">
                  <Input
                    type="number"
                    name="winCoinsTo"
                    id="winCoinsTo"
                    value={winCoinsTo}
                    // onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}


                    onChange={(e) => {
                      let raw = e.target.value;

                      if (raw.length > 9) {
                        raw = raw.slice(0, 9);
                      }

                      if (raw === '') {
                        this.setState({ winCoinsTo: '' });
                        return;
                      }

                      const num = Number(raw);
                      const value = Math.max(0, num);
                      this.setState({ winCoinsTo: value });
                    }}
                    onBlur={() => {
                      if (winCoinsTo === '') {
                        this.setState({ winCoinsTo: 0 });
                      }
                    }}
                    onKeyDown={this.numbersOnly}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
                <Col sm="2"/>
                
                <Col sm="1">
                  <Input
                    type="number"
                    name="lossPointsFrom"
                    id="lossPointsFrom"
                    value={lossPointsFrom}
                    // onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) => {
                      let raw = e.target.value;

                      if (raw.length > 9) {
                        raw = raw.slice(0, 9);
                      }

                      if (raw === '') {
                        this.setState({ lossPointsFrom: '' });
                        return;
                      }

                      const num = Number(raw);
                      const value = Math.max(0, num);
                      this.setState({ lossPointsFrom: value });
                    }}
                    onBlur={() => {
                      if (lossPointsFrom === '') {
                        this.setState({ lossPointsFrom: 0 });
                      }
                    }}
                    onKeyDown={this.numbersOnly}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
                <Col sm="1">
                  <Input
                    type="number"
                    name="lossPointsTo"
                    id="lossPointsTo"
                    value={lossPointsTo}
                    // onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) => {
                      let raw = e.target.value;

                      if (raw.length > 9) {
                        raw = raw.slice(0, 9);
                      }

                      if (raw === '') {
                        this.setState({ lossPointsTo: '' });
                        return;
                      }

                      const num = Number(raw);
                      const value = Math.max(0, num);
                      this.setState({ lossPointsTo: value });
                    }}
                    onBlur={() => {
                      if (lossPointsTo === '') {
                        this.setState({ lossPointsTo: 0 });
                      }
                    }}
                    onKeyDown={this.numbersOnly}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
                <Col sm="1">
                  <Input
                    type="number"
                    name="lossCoinsFrom"
                    id="lossCoinsFrom"
                    value={lossCoinsFrom}
                    // onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) => {
                      let raw = e.target.value;

                      if (raw.length > 9) {
                        raw = raw.slice(0, 9);
                      }

                      if (raw === '') {
                        this.setState({ lossCoinsFrom: '' });
                        return;
                      }

                      const num = Number(raw);
                      const value = Math.max(0, num);
                      this.setState({ lossCoinsFrom: value });
                    }}
                    onBlur={() => {
                      if (lossCoinsFrom === '') {
                        this.setState({ lossCoinsFrom: 0 });
                      }
                    }}
                    onKeyDown={this.numbersOnly}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
                <Col sm="1">
                  <Input
                    type="number"
                    name="lossCoinsTo"
                    id="lossCoinsTo"
                    value={lossCoinsTo}
                    // onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                    onChange={(e) => {
                      let raw = e.target.value;

                      if (raw.length > 9) {
                        raw = raw.slice(0, 9);
                      }

                      if (raw === '') {
                        this.setState({ lossCoinsTo: '' });
                        return;
                      }

                      const num = Number(raw);
                      const value = Math.max(0, num);
                      this.setState({ lossCoinsTo: value });
                    }}
                    onBlur={() => {
                      if (lossCoinsTo === '') {
                        this.setState({ lossCoinsTo: 0 });
                      }
                    }}
                    onKeyDown={this.numbersOnly}
                    onWheel={(e) => e.target.blur()}
                  />
                </Col>
                
              </Row>
            </Col>
          </Row>
          <Row className="d-flex align-items-center justify-content-center mt-3">
            <Col sm="1">
              <Button onClick={this.filter}>
                Filter
              </Button>
            </Col>
            <Col sm="1">
              <Button onClick={this.resetFilters}>
                Reset
              </Button>
            </Col>

          </Row>
          <Row>
            <Col sm="12" className="text-center">
              {filteredRoomsLogs && (
                <h3>Filtered {filteredRoomsLogs.length} results out of {totalRoomCount} rooms in total</h3>
              )}
            </Col>
          </Row>

          <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
            <colgroup>
              <col span="1" className="" />
            </colgroup>
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>
                  Date
                </th>
                <th style={{ textAlign: 'center' }}>
                  Room Id
                </th>
                <th style={{ textAlign: 'center' }}>
                  Tournament Id
                </th>
                <th style={{ textAlign: 'center' }}>
                  Close Reason
                </th>
                <th style={{ textAlign: 'center' }}>
                  Time between create and joining second player
                </th>
                <th style={{ textAlign: 'center' }}>
                  Time between create room and start to play
                </th>
                <th style={{ textAlign: 'center' }}>
                  Time between create and close
                </th>
                <th style={{ textAlign: 'center' }}>
                  Close Date
                </th>
                <th style={{ textAlign: 'center' }}>
                  Parties
                </th>
                <th style={{ textAlign: 'center' }}>
                  View
                </th>
              </tr>
            </thead>
            <tbody>
              {this.table()}
            </tbody>
          </table>
        </div>
        <Modal container={`div > div`} isOpen={openModal} toggle={this.toggle} style={{ maxWidth: '65%' }}>
          <ModalHeader toggle={this.toggle}>
            {room ? `Room: ${room.roomId}, Game type: ${room.smallGame ? `${room.gameType ? room.gameType : 'P'}M` : `${room.gameType ? room.gameType : 'P'}`}, Bet: ${room.bet}, Speed: ${constants.SPEED_TYPE[room.speed]}, ${room.minGames ? `Min Games: ${room.minGames}` : ''}, ${room.studentRoom ? '2' : (room.fourPRoom ? '4' : '3')} Players, Private: ${roomData?.[room?.roomId]?.privateRoom ? 'Yes' : 'No'}` : ''}
          </ModalHeader>
          <ModalBody>
            <RoomLogs roomData={roomData} roomId={roomId} roomParams={room} bots={bots} offset={offset} />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>Close</Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default withTranslation('admin')(AdminLogsRooms);
